import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { translate } from "react-i18next";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import CheckIcon from "@material-ui/icons/Check";
import { AppMenu } from "../AppMenu";
import { THEME,gbConstants } from "../_constants";
import Charts from "./Chart";
import ChartFilter from "./ChartFilter";
import { campaignService } from "../_services";
import { images } from "../_assets";
import { history } from "../_helpers";

const styles = theme => ({
    container: {
        position: "fixed",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        display: "flex",
        flexDirection: "column"
    },
    body: {
        height: "100%",
        display: "flex",
        flexDirection: "row"
    },
    heading: {
        fontSize: theme.typography.pxToRem(18)
    }
});

class CampaignDetailCharts extends React.Component {
    constructor(props) {
        super(props);
        this.state = { campaign: props.location.state.campaign };
    }

    updateDimensions() {
        const height = window.innerHeight;
        this.setState({
            anchorEl: null,
            height: height
        });
    }

    componentWillMount() {
        this.updateDimensions();
    }

    componentDidMount() {

    }

    componentWillUnmount() {
    }

    handleClick = event => {
        if (this.state.anchorEl) {
            this.setState({
                anchorEl: null
            });
        } else {
            this.setState({
                anchorEl: event.currentTarget
            });
        }
    };

    handleClose = () => {
        this.setState({
            anchorEl: null
        });
    };
    openCampaign() {
        let campaign 
        if(this.state.campaign.id == this.props.location.state.campaign.id){
            campaign = this.props.location.state.campaign
        }else {
            campaign = this.state.campaign
        }
        let campaignList = this.props.location.state.campaignList
        history.push({
            pathname: gbConstants.PATH_CAMPAIGN_DETAIL,
            state: {campaign,campaignList }
        });
    }
    render() {
        const { classes, location } = this.props;
        let campaign = this.state.campaign;
        let campaignList = location.state.campaignList;
        const { anchorEl } = this.state;
        function isSelectedCampaign(iCampaign) {
            let isSelected = iCampaign.id === campaign.id;

            return isSelected;
        }
        let mapImage = (
                <svg width="35" height="40" viewBox="0 0 1024 1024" 
                    style={{
                        fill:"#269a89",
                        cursor:"pointer"
                    }} 
                    onClick={()=>this.openCampaign()}>
               <path d={images.map}></path>
               </svg>
        )
        let dropdown = (
            <div>
                <ExpansionPanel
                    defaultExpanded
                    onChange={this.handleClick}
                    style={{ zIndex: 1301, boxShadow: "none" }}
                >
                    <ExpansionPanelSummary
                        expandIcon={
                            <ExpandMoreIcon
                                style={{ color: THEME.COLOR.GRAY_EXPAND_ICON }}
                            />
                        }
                    >
                        <div className={classes.column}>
                            <Typography
                                variant="title"
                                className={classes.heading}
                            >
                                {campaign.name}
                            </Typography>
                        </div>
                    </ExpansionPanelSummary>
                </ExpansionPanel>
                <Popover
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={this.handleClose}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center"
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "center"
                    }}
                >
                    <List>
                        {campaignList.map(iCampaign => {
                            let isSelected = isSelectedCampaign(iCampaign);
                            return (
                                <ListItem
                                    style={{
                                        backgroundColor: isSelected
                                            ? THEME.COLOR.GRAY
                                            : "white"
                                    }}
                                    key={iCampaign.id}
                                    onClick={() => {
                                        this.setState({ campaign: iCampaign });
                                        this.handleClose();
                                    }}
                                >
                                    <ListItemText primary={iCampaign.name} />
                                    {isSelected ? (
                                        <ListItemSecondaryAction>
                                            <IconButton aria-label="Check">
                                                <CheckIcon />
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    ) : null}
                                </ListItem>
                            );
                        })}
                    </List>
                </Popover>
            </div>
        );

        return (
            <div className={classes.container}>
                <AppMenu location={location} title={dropdown} image={mapImage}/>
                <div style={{position:"relative"}} className={classes.body}>
                    <div style={{paddingLeft:"2%",paddingRight:"2%",width:"76%",overflow:"auto",position:"relative",float:"left"}}>
                        <Charts charttype="bydate"/>
                        <Charts charttype="byhour"/>
                        <Charts charttype="byarea"/>
                        <Charts charttype="bydt"/>
                        <Charts charttype="byad"/>
                        <Charts charttype="byat"/>
                        <Charts charttype="bydriver"/>
                    </div>
                    
                    <div style={{width:"20%",position:"relative",float:"left"}}>
                        <ChartFilter campaign={campaign} />
                    </div>
                </div>
            </div>
        );
    }
}

const styleRegister = withStyles(styles)(
    translate("translations")(CampaignDetailCharts)
);

export { styleRegister as CampaignDetailCharts };
                


// WEBPACK FOOTER //
// ./src/CampaignDetailCharts/CampaignDetailCharts.js